import React from "react";
import {IApplication} from "@src/Components/Pages/Main/Content/ApplicationsPage/Interfaces/interfaces";
import {Button, Dialog, DialogActions, DialogContent} from "@material-ui/core";
import {Values} from "Tools/Values";
import AppInfoHeader from "./AppInfoHeader/AppInfoHeader";
import AppPermissions from "./AppPermissions/AppPermissions";
import UserRoles from "./UserRoles/UserRoles";
import Dependencies from "./Dependencies/Dependencies";

interface IProps {
    app: IApplication;
    isOpened: boolean;
    onClose: () => void;
    isAdmin: boolean;
    onActivationButtonClick: () => void;
}

export const ExternalAppDialog = (props: IProps) => (
    <Dialog
        maxWidth="lg"
        open={props.isOpened}
        onClose={() => props.onClose()}
    >

        <DialogContent style={{minWidth: 500, paddingBottom: 32}}>
            <AppInfoHeader
                app={props.app}
                isAdmin={props.isAdmin}
                onActivationButtonClick={() => props.onActivationButtonClick()}
            />

            <AppPermissions
                permissions={props.app?.scopes?.filter(x => x.isOptional == false)}
            />

            <AppPermissions
                permissions={props.app?.scopes?.filter(x => x.isOptional)}
                isOptional
            />
            <UserRoles
                userRoles={props.app.roles}
            />
            <Dependencies
                dependencies={props.app.dependencies}
            />
        </DialogContent>

        <DialogActions style={{padding: 16}}>
            <Button
                variant="contained"
                onClick={props.onClose}
                color="default"
            >
                {Values.getLocalizationValue('close')}
            </Button>
        </DialogActions>
    </Dialog>
)
